import { Button } from "@bleu.builders/ui";
import { ChevronRightIcon } from "@radix-ui/react-icons";
import { Calculator } from "lucide-react";
import React from "react";

import { formatDate } from "#/lib/formatDate";

import { Link } from "../Link";

const FieldLayout = ({ children, title }) => {
  return (
    <div className="flex flex-col gap-2">
      <div className="flex gap-1 justify-start items-center">
        <ChevronRightIcon className="size-5 text-primary font-bold" />
        <label className="text-xl text-primary font-bold">{title}</label>
      </div>
      <div className="ml-7">{children}</div>
    </div>
  );
};

const CalculatorField = ({ value, title }) => {
  return (
    <FieldLayout title={title}>
      <Link to={`/simulate-calculation/${value}`}>
        <Button className="gap-2 text-lg">
          <Calculator /> Simular Cálculo
        </Button>
      </Link>
    </FieldLayout>
  );
};

const TextField = ({ value, title, ...props }) => {
  if (props.field_options?.mode === "calculator") {
    return <CalculatorField value={value} title={title} />;
  }

  return (
    <FieldLayout title={title}>
      <span className="prose prose-a:text-blue-600 hover:prose-a:text-blue-500">
        {value}
      </span>
    </FieldLayout>
  );
};

const DateField = ({ value, title }) => {
  return (
    <FieldLayout title={title}>
      <span className="text-md text-foreground">{formatDate(value)}</span>
    </FieldLayout>
  );
};

const FileField = ({ value, title }) => {
  if (!value.url) return null;

  return (
    <FieldLayout title={title}>
      <Link to={value.url} target="_blank">
        <Button>Download</Button>
      </Link>
    </FieldLayout>
  );
};

const RichText = ({ title, value }) => {
  return (
    <FieldLayout title={title}>
      <div
        className="prose prose-a:text-blue-600 hover:prose-a:text-blue-500"
        dangerouslySetInnerHTML={{ __html: value }}
      />
    </FieldLayout>
  );
};

const CheckboxField = () => {
  return <div>CheckboxField</div>;
};

const SwitchField = () => {
  return <div>SwitchField</div>;
};

const RadioGroupField = () => {
  return <div>RichText</div>;
};

const RadiusSelect = () => {
  return <div>RadiusSelect</div>;
};

export const detailsFieldsComponents = {
  input: TextField,
  checkbox: CheckboxField,
  radio_item: RadioGroupField,
  text: TextField,
  date: DateField,
  datetime: DateField,
  file: FileField,
  switch: SwitchField,
  select: TextField,
  multi_select: TextField,
  wysiwyg: RichText,
  radius_select: RadiusSelect,
} as const;

export function detailsPageBuilder(data) {
  const formElements = data.map(({ title, type, value, ...rest }) => {
    const FieldComponent = detailsFieldsComponents[type];
    if (!FieldComponent) {
      throw new Error(`Invalid field type: ${type}`);
    }
    if (!value) return null;
    return <FieldComponent value={value} title={title} {...rest} />;
  });

  return formElements;
}
